import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

const getVideoId = (url) => {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^?&\s]+)/);
  return m ? m[1] : null;
};

// Fallback — only shows when NO sermons in admin
const FALLBACK = [
  { videoId:'ktCkchkkF-0', title:"The Power of Prayer & God's Provision", preacher:'Pastor Philip Rajkumar', verse:'"Ask and it will be given to you…" — Matthew 7:7', description:"A powerful message on how God answers prayers. Trusting God through every season.", youtube_url:'https://youtu.be/ktCkchkkF-0' },
  { videoId:'q3hVdTzTjGs', title:'Standing Firm in Faith', preacher:'Pastor Philip Rajkumar', verse:'"Be strong in the Lord and in His mighty power." — Ephesians 6:10', description:"A stirring word on walking in the strength of the Lord and overcoming trials.", youtube_url:'https://youtu.be/q3hVdTzTjGs' },
  { videoId:'_zJYqpIvrTE', title:'Grace That Transforms Lives', preacher:'Pastor Betty Suzanna', verse:'"For it is by grace you have been saved, through faith." — Ephesians 2:8', description:"A heart-touching message about the transforming grace of God.", youtube_url:'https://youtu.be/_zJYqpIvrTE' },
];

export default function Sermons() {
  const [sermons, setSermons] = useState(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    supabase
      .from('sermons')
      .select('*')
      .eq('published', true)
      .order('created_at', { ascending: false })
      .limit(6)
      .then(({ data }) => {
        if (cancelled) return;
        if (data && data.length > 0) {
          // Only keep sermons with valid YouTube URL
          const valid = data
            .map(s => ({ ...s, videoId: getVideoId(s.youtube_url) }))
            .filter(s => s.videoId);
          // Admin has sermons → replace fallback completely
          if (valid.length > 0) setSermons(valid);
        }
        // No admin sermons → keep FALLBACK
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <section id="sermons" className="section" style={{ background: 'linear-gradient(180deg,var(--bg-deep) 0%,var(--bg-dark) 100%)' }}>
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <span className="section-tag">✦ Hear The Word</span>
          <h2 className="section-title">Recent <span>Sermons</span></h2>
          <div className="divider center" />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(310px,1fr))', gap: 22 }}>
          {sermons.map((s, i) => (
            <div key={i} className="card fade-up" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <a href={s.youtube_url} target="_blank" rel="noreferrer" style={{ display: 'block', position: 'relative', overflow: 'hidden' }}>
                <img
                  src={`https://img.youtube.com/vi/${s.videoId}/hqdefault.jpg`}
                  alt={s.title}
                  style={{ width: '100%', height: 190, objectFit: 'cover', display: 'block', transition: 'transform 0.3s' }}
                  onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
                  onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                  onError={e => { e.target.style.display = 'none'; }}
                />
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.25)' }}>
                  <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(255,0,0,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', paddingLeft: 4 }}>▶</div>
                </div>
              </a>
              <div style={{ padding: '20px 22px', flex: 1 }}>
                <h4 style={{ fontFamily: "'Cinzel Decorative',serif", fontSize: '0.82rem', color: 'var(--primary)', marginBottom: 8, lineHeight: 1.4 }}>{s.title}</h4>
                <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 10 }}>
                  <span style={{ color: 'var(--primary)' }}>✝</span> {s.preacher}
                </div>
                {s.verse && <p style={{ fontFamily: "'Crimson Pro',serif", fontStyle: 'italic', fontSize: '0.9rem', color: '#f0e8d8', marginBottom: 8, lineHeight: 1.5 }}>{s.verse}</p>}
                {s.description && <p style={{ fontFamily: "'Crimson Pro',serif", fontSize: '0.88rem', color: 'var(--text-muted)', lineHeight: 1.6 }}>{s.description}</p>}
              </div>
              <a href={s.youtube_url} target="_blank" rel="noreferrer"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '13px', background: 'rgba(255,0,0,0.1)', color: '#ff6b6b', fontSize: '0.72rem', letterSpacing: '0.12em', textTransform: 'uppercase', textDecoration: 'none', fontWeight: 700, borderTop: '1px solid rgba(255,0,0,0.15)', transition: 'background 0.25s' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,0,0,0.2)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,0,0,0.1)'}
              >▶ Watch on YouTube</a>
            </div>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: 36 }}>
          <a href="https://youtube.com/@zionaogooty" target="_blank" rel="noreferrer" className="btn-outline">
            View All Sermons on YouTube
          </a>
        </div>
      </div>
    </section>
  );
}
